/** ISLEM_SABLON satırlarından randevu (CI_RAN_TAR) tarihi hesaplama — şablon uygula / tedavi tarihi yenileme */

function skipSunday(d) {
    const nd = new Date(d);
    if (nd.getDay() === 0) nd.setDate(nd.getDate() + 1);
    return nd;
}

/**
 * Tek şablon satırı için randevu tarihi (IslemPanel applySablon ile aynı mantık).
 */
export function computeRandevuForSablonLine(sablonLine, baslangicTar, oncekiRandevuTarih) {
    const s = sablonLine || {};
    const yilEkle = s.IS_YILSAY || 0;
    const ayEkle = s.IS_AYSAY || 0;
    const gunEkle = s.IS_GUNSAY || 0;

    let bazTarih;
    if (s.IS_ONCEKINDEN_SAY && oncekiRandevuTarih) {
        bazTarih = new Date(oncekiRandevuTarih);
    } else {
        bazTarih = new Date(baslangicTar);
    }

    let ekstraGun = 0;
    if (!s.IS_ILKGUN_DAHIL && (yilEkle > 0 || ayEkle > 0 || gunEkle > 0)) {
        ekstraGun = 1;
    }

    const randevuTarih = new Date(bazTarih);
    randevuTarih.setFullYear(randevuTarih.getFullYear() + yilEkle);
    randevuTarih.setMonth(randevuTarih.getMonth() + ayEkle);
    randevuTarih.setDate(randevuTarih.getDate() + gunEkle + ekstraGun);

    if (randevuTarih.getDay() === 0) {
        randevuTarih.setDate(randevuTarih.getDate() + 1);
    }
    return randevuTarih;
}

export function hasAnyCompletedIslem(islemRows) {
    return (islemRows || []).some((r) => r?.CI_ISL_TAR != null && r?.CI_ISL_TAR !== '');
}

export const SABLON_COMPLETED_BLOCK_MESSAGE =
    'Hastaya işlem yapılmış. Otomatik şablon değiştiremezsiniz. Ekrandan manuel ekle, düzelt, çıkar yapabilirsiniz.';

/**
 * Mevcut işlem satırları + şablon detay satırları ile CI_RAN_TAR güncellemeleri üretir.
 * İşlemler mevcut randevu sırasına göre şablon IS_SIRA ile eşleştirilir (CI_TUR = IS_TUR).
 */
export function recalcIslemRandevuUpdates(islemRows, sablonDetayLines, baslangicTar) {
    if (!Array.isArray(islemRows) || !islemRows.length || !Array.isArray(sablonDetayLines) || !sablonDetayLines.length) {
        return [];
    }
    if (!baslangicTar) return [];

    const sortedIslem = [...islemRows]
        .filter((r) => Number(r?.CI_REF ?? r?.ci_ref ?? 0) > 0)
        .sort((a, b) => {
            const ta = new Date(a.CI_RAN_TAR).getTime();
            const tb = new Date(b.CI_RAN_TAR).getTime();
            if (Number.isFinite(ta) && Number.isFinite(tb) && ta !== tb) return ta - tb;
            return Number(a.CI_REF) - Number(b.CI_REF);
        });

    const sablonSirali = [...sablonDetayLines].sort((a, b) => (Number(a.IS_SIRA) || 0) - (Number(b.IS_SIRA) || 0));
    const unassigned = new Set(sortedIslem.map((r) => Number(r.CI_REF ?? r.ci_ref)));
    const baslangic = new Date(baslangicTar);
    if (isNaN(baslangic.getTime())) return [];

    const updates = [];
    let oncekiRandevuTarih = null;

    sablonSirali.forEach((s) => {
        const match = sortedIslem.find(
            (r) => unassigned.has(Number(r.CI_REF ?? r.ci_ref))
                && Number(r.CI_TUR) === Number(s.IS_TUR)
        );
        if (!match) return;
        unassigned.delete(Number(match.CI_REF ?? match.ci_ref));
        const randevuTarih = computeRandevuForSablonLine(s, baslangic, oncekiRandevuTarih);
        oncekiRandevuTarih = randevuTarih;
        updates.push({
            CI_REF: Number(match.CI_REF ?? match.ci_ref),
            CI_RAN_TAR: randevuTarih.toISOString(),
        });
    });

    return updates;
}

/** Şablon satırlarından yeni insert kayıtları (applySablon). */
export function buildIslemInsertsFromSablon(sablonLines, baslangicTar, buildCiDetayFromSablon, selectedSablon, initialOncekiTar = null) {
    const sablonSirali = [...(sablonLines || [])].sort((a, b) => (Number(a.IS_SIRA) || 0) - (Number(b.IS_SIRA) || 0));
    const baslangic = baslangicTar ? new Date(baslangicTar) : new Date();
    let oncekiRandevuTarih = initialOncekiTar ? new Date(initialOncekiTar) : null;
    const yeni = [];

    sablonSirali.forEach((s) => {
        const randevuTarih = computeRandevuForSablonLine(s, baslangic, oncekiRandevuTarih);
        oncekiRandevuTarih = randevuTarih;
        yeni.push({
            CI_TUR: s.IS_TUR,
            CI_SEANS_SAY: 0,
            CI_RAN_TAR: randevuTarih.toISOString(),
            CI_ISL_TAR: null,
            CI_ACK: '',
            CI_DETAY: buildCiDetayFromSablon(s.IS_DETAY, selectedSablon),
        });
    });

    return yeni;
}

export { skipSunday };
